import VendorConsole from './components';

export default {
  protected: true,
  path: '/vendorconsole/:vendorId',
  key: '/vendorconsole/',
  exact: true,
  component: VendorConsole,
};
